<template>
  <el-form-item label="图片：">
    <imageSelect :url.sync="tempValue" />
  </el-form-item>
</template>

<script>
import imageSelect from "@client/components/image-select";
import { mapState, mapGetters } from "vuex";
export default {
  name: "attr-qk-imageSrc",
  props: {
    imageSrc: String,
  },
  computed: {
    ...mapState({
      projectData: (state) => state.editor.projectData,
      activePageUUID: (state) => state.editor.activePageUUID,
      activeElementUUID: (state) => state.editor.activeElementUUID,
    }),
    ...mapGetters([
      "currentPageIndex",
      "activeElementIndex",
      "activeElement",
      "activePage",
    ]),
  },
  components: {
    imageSelect,
  },
  data() {
    return {
      tempValue: "",
    };
  },
  mounted() {
    this.tempValue = this.imageSrc;
  },
  methods: {
    imageOriginValueInit(refresh) {
      const image = new Image();
      image.onload = () => {
        if (refresh) {
          // 判断是否为组合内的元件，是，则不更新尺寸 ---- 若更新，则to do，更新组合内的相对位置信息
          if (
            !this.activePage.elementGroups.find(
              (i) =>
                i.list &&
                i.list.length > 0 &&
                i.list.includes(this.activeElement.uuid)
            )
          ) {
            this.activeElement.commonStyle.width = image.width;
            this.activeElement.commonStyle.height = image.height;
          }
        }
        this.activeElement.originValue = {
          width: image.width,
          height: image.height,
        };
      };
      image.src = this.tempValue;
    },
  },
  watch: {
    imageSrc(val) {
      this.tempValue = val;
    },
    tempValue() {
      const refresh = this.tempValue != this.imageSrc;
      this.$emit("update:imageSrc", this.tempValue);
      this.imageOriginValueInit(refresh);
    },
  },
};
</script>

<style scoped></style>
